const SYS_DICT = {
    zhengzhiType: [{
        value: '党员'
    }, {
        value: '预备党员'
    }, {
        value: '团员'
    }, {
        value: '群众'
    }, {
        value: '其他党派'
    }],
    province: [{
        'label': '北京市',
        'value': '110000'
    }, {
        'label': '天津市',
        'value': '120000'
    }, {
        'label': '河北省',
        'value': '130000'
    }, {
        'label': '山西省',
        'value': '140000'
    }, {
        'label': '内蒙古自治区',
        'value': '150000'
    }, {
        'label': '辽宁省',
        'value': '210000'
    }, {
        'label': '吉林省',
        'value': '220000'
    }, {
        'label': '黑龙江省',
        'value': '230000'
    }, {
        'label': '上海市',
        'value': '310000'
    }, {
        'label': '江苏省',
        'value': '320000'
    }, {
        'label': '浙江省',
        'value': '330000'
    }, {
        'label': '安徽省',
        'value': '340000'
    }, {
        'label': '福建省',
        'value': '350000'
    }, {
        'label': '江西省',
        'value': '360000'
    }, {
        'label': '山东省',
        'value': '370000'
    }, {
        'label': '河南省',
        'value': '410000'
    }, {
        'label': '湖北省',
        'value': '420000'
    }, {
        'label': '湖南省',
        'value': '430000'
    }, {
        'label': '广东省',
        'value': '440000'
    }, {
        'label': '广西壮族自治区',
        'value': '450000'
    }, {
        'label': '海南省',
        'value': '460000'
    }, {
        'label': '重庆市',
        'value': '500000'
    }, {
        'label': '四川省',
        'value': '510000'
    }, {
        'label': '贵州省',
        'value': '520000'
    }, {
        'label': '云南省',
        'value': '530000'
    }, {
        'label': '西藏自治区',
        'value': '540000'
    }, {
        'label': '陕西省',
        'value': '610000'
    }, {
        'label': '甘肃省',
        'value': '620000'
    }, {
        'label': '青海省',
        'value': '630000'
    }, {
        'label': '宁夏回族自治区',
        'value': '640000'
    }, {
        'label': '新疆维吾尔自治区',
        'value': '650000'
    }, {
        'label': '澳门特别行政区',
        'value': '820000'
    }, {
        'label': '香港特别行政区',
        'value': '810000'
    }, {
        'label': '台湾省',
        'value': '710000'
    }],
    gender: [{
        value: '男'
    }, {
        value: '女'
    }],
    yesNo: [{
        value: '是'
    }, {
        value: '否'
    }],
    nation: [{
        value: '汉'
    }, {
        value: '满'
    }, {
        value: '蒙古'
    }, {
        value: '回'
    }, {
        value: '藏'
    }, {
        value: '维吾尔'
    }, {
        value: '苗'
    }, {
        value: '彝'
    }, {
        value: '壮'
    }, {
        value: '布依'
    }, {
        value: '侗'
    }, {
        value: '瑶'
    }, {
        value: '白'
    }, {
        value: '土家'
    }, {
        value: '哈尼'
    }, {
        value: '哈萨克'
    }, {
        value: '傣'
    }, {
        value: '黎'
    }, {
        value: '傈僳'
    }, {
        value: '佤'
    }, {
        value: '畲'
    }, {
        value: '高山'
    }, {
        value: '拉祜'
    }, {
        value: '水'
    }, {
        value: '东乡'
    }, {
        value: '纳西'
    }, {
        value: '景颇'
    }, {
        value: '柯尔克孜'
    }, {
        value: '土'
    }, {
        value: '达斡尔'
    }, {
        value: '仫佬'
    }, {
        value: '羌'
    }, {
        value: '布朗'
    }, {
        value: '撒拉'
    }, {
        value: '毛南'
    }, {
        value: '仡佬'
    }, {
        value: '锡伯'
    }, {
        value: '阿昌'
    }, {
        value: '普米'
    }, {
        value: '朝鲜'
    }, {
        value: '塔吉克'
    }, {
        value: '怒'
    }, {
        value: '乌孜别克'
    }, {
        value: '俄罗斯'
    }, {
        value: '鄂温克'
    }, {
        value: '德昂'
    }, {
        value: '保安'
    }, {
        value: '裕固'
    }, {
        value: '京'
    }, {
        value: '塔塔尔'
    }, {
        value: '独龙'
    }, {
        value: '鄂伦春'
    }, {
        value: '赫哲'
    }, {
        value: '门巴'
    }, {
        value: '珞巴'
    }, {
        value: '基诺'
    }, {
        value: '穿青人'
    }],
    canbaoType: [{
        value: '新参统'
    }, {
        value: '调入'
    }],
    hukouType: [{
        value: '北京城镇'
    }, {
        value: '北京农业'
    }, {
        value: '外地城镇'
    }, {
        value: '外地农业'
    }, {
        value: '港澳台'
    }],
    xueliType: [{
        value: '博士'
    }, {
        value: '硕士'
    }, {
        value: '本科'
    }, {
        value: '大专'
    }, {
        value: '中专'
    }, {
        value: '高中'
    }, {
        value: '初中'
    }, {
        value: '小学'
    }, {
        value: '其它'
    }],
    xueliTypeMax: [{
        value: '博士研究生'
    }, {
        value: '硕士研究生'
    }, {
        value: '大学本科'
    }, {
        value: '大学专科'
    }, {
        value: '高中'
    }, {
        value: '中专'
    }, {
        value: '技校'
    }, {
        value: '初中及以下'
    }],
    zhicheng: [{
        value: '无'
    }, {
        value: '初级职称'
    }, {
        value: '中级职称'
    }, {
        value: '高级职称'
    }],
    danganAddressType: [{
        value: '农户无档案'
    }, {
        value: '学校'
    }, {
        value: '原工作单位'
    }, {
        value: '个人在人才存档'
    }, {
        value: '个人在职介存档'
    }, {
        value: '街道失业状态'
    }],
    emergency1Relation: [{
        value: '父母'
    }, {
        value: '配偶'
    }, {
        value: '子女'
    }, {
        value: '其它'
    }],
    paiqianRyType: [{
        value: '应届'
    }, {
        value: '在职'
    }],
    gangwei: [{
        value: '医疗',
        children: [{
            value: '管理岗'
        }]
    }, {
        value: '药剂',
        children: [{
            value: '管理岗'
        }]
    }, {
        value: '护理',
        children: [{
            value: '管理岗'
        }]
    }, {
        value: '工勤',
        children: [{
            value: '非管理岗'
        }]
    }, {
        value: '其他',
        children: [{
            value: '管理岗'
        }]
    }],
    applyStatus: [{
        'label': '待办理',
        'value': 10
    }, {
        'label': '已取消',
        'value': 20
    }, {
        'label': '已过期',
        'value': 30
    }, {
        'label': '已办理',
        'value': 40
    }],
    certStatus: [{
        'label': '已取消',
        'value': -1
    }, {
        'label': '待审核',
        'value': 0
    }, {
        'label': '已通过',
        'value': 1
    }, {
        'label': '已拒绝',
        'value': 2
    }],
    contractStatus: [{
        label: '待审核',
        value: 1
    }, {
        label: '已审',
        value: 2
    }, {
        label: '待个人签署',
        value: 3
    }, {
        label: '个人签署',
        value: 4
    }, {
        label: '待单位签署',
        value: 5
    }, {
        label: '签署完成',
        value: 6
    }, {
        label: '过期未签署',
        value: 7
    }, {
        label: '拒签',
        value: 8
    }, {
        label: '已作废',
        value: 9
    }]
}
Object.freeze(SYS_DICT)

export function getSysDict(name) {
    return SYS_DICT[name] || []
}

export function getSysDictAync(name) {
    return SYS_DICT[name] || []
}

const filterCache = {};

export function createFilter(name) {
    if (filterCache[name]) {
        return filterCache[name];
    }
    const dictList = (SYS_DICT[name] || []);
    filterCache[name] = function (value) {
        return dictList.find((item) => {
            return item.value == value
        }).label
    }
    return filterCache[name];
}

export const notifyContent = `<div class="notify-content">
1.员工本人保证填写的入职信息真实有效，并授权我单位（或被派遣单位）对本人填写内容进行核实。如有虚假信息，我单位可按严重违反规章制度解除劳动合同，同时追究由此产生的所有责任。\r\n
2.员工本人在办理入职时应保证符合国家法定劳动年龄的规定，且与其他单位、经济组织、团体无劳动关系；若违反前述承诺，导致我单位被追究责任的，所有责任均由本人承担。\r\n
3.如员工本人与其他单位签订保密协议、竞业限制协议的，应以书面形式向我单位说明情况。\r\n
4.员工入职后不得将相关信息（包括但不限于工资）未经我单位许可向第三方透露。员工在职期间或离职之后，我单位可以依法将员工本人在本单位的情况对外公布或向有需要的第三方提供。\r\n
5.有工作经历的员工，本人入职时应提交原单位出具的真实有效的离职证明书，由原单位或以个人形式在人才中介机构缴纳社会保险的，须办理减员手续。因未及时减员产生的后果，我单位不承担责任。\r\n
6.北京市城镇户口档案在职介的“灵活就业”人员、档案在街道的登记失业人员、正在领取失业金期间的人员、享受4050政策的人员，应当办理完相关手续后方可签订劳动合同。\r\n
7.员工办理入职时，应按时领取入职材料（包括但不限于员工手册），如实填写“卫人派遣”APP，认真阅读并严格遵守员工手册及被派遣单位的各项规章制度，按时参加岗前培训。\r\n
8.我单位及被派遣单位可根据实际情况更新员工手册、规章制度与劳动纪律，员工应当随时关注“卫人派遣”APP及被派遣单位通过各种方式公示的信息。\r\n
9.入职时如有任何兼职行为，应以书面形式向本单位说明情况。与本单位工作有关或影响本职工作的，未经本单位书面同意，不得从事任何形式的兼职行为。\r\n
10.其他需向本单位告知或说明的情况（包括但不限于是否与原单位存在未结劳动纠纷争议案件、涉嫌违法犯罪、被追究刑事责任等情形），应在入职时以书面形式向本单位说明情况。
</div>`;
